import { useTranslation } from '@jobcost-monorepo/i18n';
import { CurrencyInputForm } from '@jobcost-monorepo/ui';
import { ChangeEvent, FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const DailyCost: FC = () => {
  const fieldTotalName = 'dailyCost';
  const fieldSingleName = 'hourCost';
  const { t } = useTranslation('commons');
  const { setValue, watch } = useFormContext();
  const fieldSingleValue = watch(fieldSingleName);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    if (value && !Number.isNaN(value))
      setValue(String(fieldSingleName), value / 8);
    else setValue(String(fieldSingleName), 0);
  };

  useEffect(() => {
    setValue(fieldTotalName, Number(fieldSingleValue) * 8);
  }, [fieldSingleValue]);

  return (
    <CurrencyInputForm
      name={fieldTotalName}
      id={fieldTotalName}
      onChange={handleChange}
      autoComplete="off"
      errorName={fieldTotalName}
      label={t(fieldTotalName)}
    />
  );
};

export default DailyCost;
